import React from "react";
import "react-toastify/dist/ReactToastify.css";
import "@assets/css/jds.css";
import "@assets/css/app.css";
import "@assets/css/probate.css";
import "@assets/css/custom.css";
import "@assets/css/docassemble.css";
import Header from "./@core/components/header";
import Footer from "./@core/components/footer";
import ScrollToTop from "@jds/ScrollToTop/index";
import Loader from "@jds/Loader";
import Routes from "./router/routes";
import { useSelector, useDispatch } from "react-redux";
import { store } from "./redux/store";
import useJwt from "./auth/useJwt";
import { useNotification } from "@jds/Notification";
import { ToastContainer } from "react-toastify";
import { getLoginUrlDocAssemble, SaveRoute } from "./api/probateAPI";
import { moveToCurrentMenu } from "./views/pages/probate/globalstore";
import { GlobalContext } from "./context/GlobalContext";

function App() {
  // const [allRoutes, setAllRoutes] = useState<Array<any>>(AllRoutes);
  const stepStore = useSelector((state) => state.steps);
  const dispatch = useDispatch();
  const { notify, update } = useNotification();

  useJwt.store = store;
  useJwt.notify = notify;

  window.addEventListener("error", function (e) {
    const msg = e.error?.message || "";
    if (msg.indexOf("labelauty") !== -1) {
        window.location.reload();
    }
    return false;
  });
  const routeTo = async (menuItem) => {
    try {
      const response = await SaveRoute({ index: menuItem.id });
      //if (menuItem.isdocassemble) { //commented to allow to have docassemble session
      if (response.status === 200) {
        getLoginUrlDocAssemble().then((res) => {
          window.location.href = res.data.redirectURL;
          setTimeout(
            () => dispatch(moveToCurrentMenu({ route: menuItem.route })),
            1000
          );
        });
      }
      // }
      // else {
      //   navigate(menuItem.route);
      //   await dispatch(moveToCurrentMenu({ route: menuItem.route }));
      // }

      // if (menuItem.isdocassemble)
      //   setTimeout(() => window.location.reload(), 500);
    } catch (error) {
      console.error(error);
    }
    //.catch(error => console.error(error));
  };

  return (
    <>
      <GlobalContext.Provider
        value={{
          routeTo: routeTo,
        }}
      >
        <div className="wrapper">
          <Header />
          <main className="main-content">
            <React.Suspense fallback={<Loader />}>{Routes()}</React.Suspense>
          </main>
          <Footer />
          {stepStore.loading && <Loader />}
          <ToastContainer
            position="bottom-center"
            autoClose={50000}
            closeButton={false}
            style={{ width: "500px" }}
            hideProgressBar
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnHover
            limit={1}
          />
          {/* component={<i className="fas fa-chevron-up"/>} */}
        </div>
        <ScrollToTop smooth />
      </GlobalContext.Provider>
    </>
  );
}

export default App;
